/**
 * 사업계획 양식 시드 (레지스트리·카탈로그 공용)
 * — formRegistryStore 순환참조 방지용 분리
 */
export const BIZ_FORM_CATALOG_KEY = 'bizFormCatalog';
export const BIZ_FORM_TENANT_BIND_PREFIX = 'bizFormTenantBind';
export const FORM_ID_GOYANG_CULTURE_V1 = 'form-goyang-culture-v1';

export function createFormId(prefix = 'form') {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `${prefix}-${crypto.randomUUID().slice(0, 8)}`;
  }
  return `${prefix}-${Date.now().toString(36)}`;
}

export const GOYANG_CULTURE_V1_FIELDS = [
  {
    fieldId: 'header.deptName',
    hwpField: 'header.deptName',
    label: '부서',
    type: 'string',
    input: 'lookupDept',
    syncToDb: true,
    syncToFormation: true,
    guide: '부서명',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 0, cellPara: 0 },
  },
  {
    fieldId: 'doc.title',
    hwpField: 'doc.title',
    label: '사업명',
    type: 'string',
    input: 'lookupProject',
    syncToDb: true,
    syncToFormation: true,
    guide: '사업명',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 1, cellPara: 0 },
  },
  {
    fieldId: 'overview.charType',
    hwpField: 'overview.charType',
    label: '사업성격',
    type: 'enum',
    enum: ['공약', '지시', '기본'],
    input: 'select',
    syncToDb: true,
    syncToFormation: false,
    guide: '공약/지시/기본',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 9, cellPara: 0 },
  },
  {
    fieldId: 'overview.bizType',
    hwpField: 'overview.bizType',
    label: '사업구분',
    type: 'enum',
    enum: ['지속', '신규'],
    input: 'select',
    syncToDb: true,
    syncToFormation: false,
    guide: '지속/신규',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 10, cellPara: 0 },
  },
  {
    fieldId: 'overview.priority',
    hwpField: 'overview.priority',
    label: '중요도',
    type: 'number',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '중요도',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 11, cellPara: 0 },
  },
  {
    fieldId: 'staff.leaderName',
    hwpField: 'staff.leaderName',
    label: '팀장',
    type: 'string',
    input: 'deptManager',
    syncToDb: true,
    syncToFormation: false,
    guide: '팀장',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 6, cellPara: 0 },
  },
  {
    fieldId: 'staff.leaderPhone',
    hwpField: 'staff.leaderPhone',
    label: '팀장연락처',
    type: 'string',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '팀장 연락처',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 8, cellPara: 0 },
  },
  {
    fieldId: 'staff.staffName',
    hwpField: 'staff.staffName',
    label: '실무자',
    type: 'string',
    input: 'sessionUser',
    syncToDb: true,
    syncToFormation: false,
    guide: '실무자',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 13, cellPara: 0 },
  },
  {
    fieldId: 'staff.staffPhone',
    hwpField: 'staff.staffPhone',
    label: '실무자연락처',
    type: 'string',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '실무 연락처',
    location: { kind: 'cell', sec: 0, para: 0, controlIdx: 2, cellIdx: 15, cellPara: 0 },
  },
  {
    fieldId: 'overview.location',
    hwpField: 'overview.location',
    label: '사업위치',
    type: 'string',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '사업위치',
    location: { kind: 'body', sec: 0, para: 3, afterSearch: '사업위치' },
  },
  {
    fieldId: 'overview.periodText',
    hwpField: 'overview.periodText',
    label: '사업기간',
    type: 'string',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '사업기간',
    location: { kind: 'body', sec: 0, para: 4, afterSearch: '사업기간' },
  },
  {
    fieldId: 'overview.costTotal',
    hwpField: 'overview.costTotal',
    label: '총사업비',
    type: 'amount',
    input: 'manual',
    syncToDb: true,
    syncToFormation: true,
    guide: '총사업비(천원)',
    location: { kind: 'body', sec: 0, para: 5, afterSearch: '총사업비' },
  },
  {
    fieldId: 'overview.contents',
    hwpField: 'overview.contents',
    label: '사업내용',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '사업내용',
    location: { kind: 'body', sec: 0, para: 6, afterSearch: '사업내용' },
  },
  {
    fieldId: 'need.effect',
    hwpField: 'need.effect',
    label: '예산투입대비효과',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '투입 대비 효과',
    location: { kind: 'body', sec: 0, para: 10 },
  },
  {
    fieldId: 'need.urgency',
    hwpField: 'need.urgency',
    label: '시급성',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '시급성',
    location: { kind: 'body', sec: 0, para: 13 },
  },
  {
    fieldId: 'need.special',
    hwpField: 'need.special',
    label: '특별고려사항',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '특별고려 사항',
    location: { kind: 'body', sec: 0, para: 16 },
  },
  {
    fieldId: 'risk.ifNotBudgeted',
    hwpField: 'risk.ifNotBudgeted',
    label: '예산미반영시문제점',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: false,
    guide: '미반영 시 문제점',
    location: { kind: 'body', sec: 0, para: 18 },
  },
  {
    fieldId: 'calcBasis.narrative',
    hwpField: 'calcBasis.narrative',
    label: '산출근거(서술)',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: true,
    guide: '산출근거 요약',
    location: { kind: 'body', sec: 0, para: 21, afterSearch: '산출근거' },
  },
  // 산출 표 — 1행(계) · 2행(편성목) 주요 셀
  {
    fieldId: 'calc.total.planAmt',
    hwpField: 'calc.total.planAmt',
    label: '계_예산액A',
    type: 'amount',
    input: 'manual',
    syncToDb: true,
    syncToFormation: true,
    guide: '계 예산액',
    location: { kind: 'cell', sec: 0, para: 23, controlIdx: 0, cellIdx: 6, cellPara: 0 },
  },
  {
    fieldId: 'calc.line1.subjectName',
    hwpField: 'calc.line1.subjectName',
    label: '편성목1',
    type: 'string',
    input: 'manual',
    syncToDb: true,
    syncToFormation: true,
    guide: '편성목',
    location: { kind: 'cell', sec: 0, para: 23, controlIdx: 0, cellIdx: 10, cellPara: 0 },
  },
  {
    fieldId: 'calc.line1.planAmt',
    hwpField: 'calc.line1.planAmt',
    label: '편성목1_예산액A',
    type: 'amount',
    input: 'manual',
    syncToDb: true,
    syncToFormation: true,
    guide: '예산액',
    location: { kind: 'cell', sec: 0, para: 23, controlIdx: 0, cellIdx: 11, cellPara: 0 },
  },
  {
    fieldId: 'calc.line1.calcDetail',
    hwpField: 'calc.line1.calcDetail',
    label: '편성목1_산출내역',
    type: 'text',
    input: 'manual',
    syncToDb: true,
    syncToFormation: true,
    guide: '산출내역',
    location: { kind: 'cell', sec: 0, para: 23, controlIdx: 0, cellIdx: 15, cellPara: 0 },
  },
];

export function buildGoyangCultureV1FormMeta() {
  return {
    formId: FORM_ID_GOYANG_CULTURE_V1,
    formName: '문화재단형 사업계획서',
    description: '부서·사업 헤더 + 개요/필요성 + 수입예산 산출표 (누름틀 삽입본)',
    sourceFile: 'biz-plan-goyang-culture-src.hwp',
    templateFile: 'biz-plan-goyang-culture-v1.hwp',
    publicUrl: '/samples/biz-plan/biz-plan-goyang-culture-v1.hwp',
    fieldMapId: 'form-goyang-culture-v1',
    pages: 2,
    amountUnit: 'THOUSAND_KRW',
    useYn: 'Y',
    fields: GOYANG_CULTURE_V1_FIELDS,
    createdAt: new Date().toISOString(),
    note: '누름틀 22개 삽입본. 재생성: node scripts/seed-biz-form-clickhere.mjs',
  };
}

